import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { DecimalProvider } from './context/DecimalContext';
import { ThemeContext } from './context/ThemeContext';
import { FINProvider } from './context/FinContext';
import { HRMProvider } from './context/HrmContext';
import store from './store';
import history from './history';
import Layouts from './layouts';
import { THEME_CONFIG } from './configs/AppConfig';
import { getCssThemeMode, THEME_OPTIONS } from './theme/themes';
import { initHotkeyListener } from 'components/shared-components/Nagaco/HotkeyManager/init_hotkey';
import './lang';
import './index.css';
const themes = {
    dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        let _theme = savedTheme || 'womenDay';
        if (THEME_OPTIONS.filter((e) => e.value === _theme).length === 0) {
            _theme = 'womenDay';
            localStorage.setItem('theme', _theme);
        }
        return _theme;
    });
    const [decimal, setDecimal] = useState(() => {
        const saveDecimal = localStorage.getItem('decimal');
        return saveDecimal || 3;
    });

    useEffect(() => {
        localStorage.setItem('theme', theme);
        localStorage.setItem('decimal', decimal);
    }, [decimal, theme]);
    useEffect(() => {
        initHotkeyListener();
    }, []);
    return (
        <div className="App">
            <ThemeContext.Provider
                value={{
                    theme,
                    setTheme,
                }}
            >
                <HRMProvider>
                    <FINProvider>
                        <DecimalProvider>
                            <Provider store={store}>
                                <BrowserRouter history={history}>
                                    <ThemeSwitcherProvider
                                        themeMap={themes}
                                        defaultTheme={getCssThemeMode(
                                            localStorage.getItem('theme') || THEME_CONFIG.currentTheme,
                                        )}
                                        insertionPoint="styles-insertion-point"
                                    >
                                        <Layouts />
                                    </ThemeSwitcherProvider>
                                </BrowserRouter>
                            </Provider>
                        </DecimalProvider>
                    </FINProvider>
                </HRMProvider>
            </ThemeContext.Provider>
        </div>
    );
}

export default App;
